export default {"src":"/_next/static/media/first_nav_active03.62f088c9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};